import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import { initCdp } from "./shared/libs/cdp";

// Set up the CDP (RudderStack) layer before first render: ensures the buffering
// stub exists and subscribes funnel events to the booking effects. No-ops
// in sandbox builds (staging / testing).
initCdp();

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(<App />);
